module.exports = __webpack_public_path__ + "static/media/ellipsis.b2557045.svg";